import { formatCents } from "@/lib/format-utils"

interface Offer {
  retailer: string
  priceCents: number
  originalPriceCents?: number | null
  inStock: boolean
}

interface OffersCardProps {
  offers: Offer[]
  /** Callback when a "View" button is clicked */
  onViewOffer?: (offer: Offer) => void
  /** Additional classes on the wrapper */
  className?: string
}

// Canonical display rule (owner ruling 07/25/2026): whole dollars drop ".00",
// real cents render exactly. Shared implementation in lib/format-utils.
function formatPrice(cents: number) {
  return formatCents(cents)
}

export function OffersCard({ offers, onViewOffer, className = "" }: OffersCardProps) {
  return (
    <div className={`bg-[#ff9951]/[0.06] rounded-lg p-5 ${className}`}>
      <h3 className="text-sm font-bold text-gray-900 mb-4 flex items-center gap-2">
        <svg className="w-4 h-4 text-[#0469f0]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
          />
        </svg>
        Current Offers
      </h3>
      <div className="space-y-3">
        {offers.map((offer) => (
          <div
            key={offer.retailer}
            className="flex items-center justify-between p-3.5 rounded-lg bg-[#ff9951]/[0.06]"
          >
            <div>
              <p className="font-bold text-gray-900 text-xs">{offer.retailer}</p>
              {offer.priceCents > 0 && (
                <div className="flex items-center gap-2">
                  <span className="text-base font-black text-gray-900">
                    {formatPrice(offer.priceCents)}
                  </span>
                  {offer.originalPriceCents && offer.originalPriceCents > 0 && (
                    <span className="text-xs text-gray-600 line-through">
                      {formatPrice(offer.originalPriceCents)}
                    </span>
                  )}
                </div>
              )}
            </div>
            <button
              onClick={() => onViewOffer?.(offer)}
              className="bg-[#ff9951] hover:bg-[#ff8533] text-[var(--color-brand-action-text)] px-5 py-1.5 rounded-lg font-bold text-xs transition-all shadow-sm active:scale-95"
            >
              View
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
